import { render, staticRenderFns } from "./Locode.vue?vue&type=template&id=1c825eb5"
import script from "./Locode.vue?vue&type=script&lang=js"
export * from "./Locode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports